import { render, staticRenderFns } from "./NotPart.vue?vue&type=template&id=3cc8a1e9"
import script from "./NotPart.vue?vue&type=script&lang=js"
export * from "./NotPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports